import "swiper/css"
// import Slide from "components/Slide"
// import { api } from "apiServer"
import { useState, useEffect } from "react"
import { Layout } from "components/common"
import TypeEvent from "utils/TypeEvent"
import SwiperChannel from "components/SwiperChannel"
import { getPropsHomePage } from "lib/dataStore"
import Image from "next/legacy/image"
import config from "lib/config"

// import Slide from "components/Slide"
// live , league , vod. banner. liveshow
//https://imgvlive.vtvcab.vn/1920X640/6874f72c-447d-43d5-ab22-c3ee4d91a6f9.png?auto=format&fit=max&w=1920
function Component({ screenblocks }) {
  const [_screenblocks, setScreenblocks] = useState(screenblocks)
  const [lastFetchTime, setLastFetchTime] = useState(Date.now())

  const fetchData = async () => {
    try {
      const timestamp = Date.now()
      const { screenblocks } = await getPropsHomePage()
      setScreenblocks(screenblocks)
      setLastFetchTime(timestamp)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        const currentTime = Date.now()
        const lastFetchTime = sessionStorage.getItem("lastFetchTime") || 0
        const timeElapsed = currentTime - lastFetchTime
        if (timeElapsed >= config.TIME_REQUEST_HOME_PAGE) {
          fetchData()
        }
      }
    }

    document.addEventListener("visibilitychange", handleVisibilityChange)

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange)
    }
  }, [lastFetchTime])

  return (
    <section className="mb-12">
      {/* <Slide2 slides={slides} /> */}

      <div className="pt-0 mx-auto  mt-0 md:mt-10 space-y-10  overflow-x-hidden max-w-screen-xl px-4 md:px-6 lg:px-4">
        <Image src="https://stvinaprod.vtvcab.vn/8d9083f9-404a-48ec-be04-e57e165eba79.png" width={1920} height={640} />
        {_screenblocks.filter((i) => i.type_block === TypeEvent.CHANNEL)?.length > 0 &&
          _screenblocks
            .filter((i) => i.type_block === TypeEvent.CHANNEL)
            ?.map((item) => {
              const { id } = item
              return (
                <div key={id}>
                  <SwiperChannel {...item} />
                </div>
              )
            })}
      </div>
    </section>
  )
}

export default Component
Component.Layout = Layout

export async function getServerSideProps() {
  let pageProps = {
    screenblocks: [],
    slides: [],
    leagues: []
  }
  try {
    pageProps = await getPropsHomePage()
  } catch (error) {
    console.log(error)
  }
  return { props: pageProps }
}
